// extracted by mini-css-extract-plugin
export default {"container":"sq-z","ratingLayout":"tq-z","ratingLabel":"uq-z","nonInteractiveRatingLabel":"vq-z"};